import React from 'react';
import { CommonHash } from 'app/types';
import styles from '../LandingForm.module.scss';
import ImageElement from './ImageElement';

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
}

const GenericFormForm = ({
  landing_cmp,
  handleChange,
  index,
}: ComponentFormProps): React.ReactElement => {
  const name = `landing_components[${index}]`;

  return (
    <>
      <div className={styles.group}>
        <ImageElement component={landing_cmp} name={name} handleChange={handleChange} />
      </div>
      <div className="form-group my-2">
        <label htmlFor={`landing_components[${index}].config['heading']`} className="fs-6 mb-2">
          Heading
        </label>
        <input
          className="form-control"
          name={`landing_components[${index}].config['heading']`}
          placeholder={'Heading'}
          onChange={handleChange}
          required={true}
          value={landing_cmp.config ? landing_cmp.config['heading'] : ''}
        />
      </div>
      <div className="form-group my-2">
        <label htmlFor={`landing_components[${index}].config['sub_heading']`} className="fs-6 mb-2">
          Sub Heading
        </label>
        <input
          className="form-control"
          name={`landing_components[${index}].config['sub_heading']`}
          placeholder={'Sub Heading'}
          onChange={handleChange}
          required={true}
          value={landing_cmp.config ? landing_cmp.config['sub_heading'] : ''}
        />
      </div>
      <div className="form-group my-2">
        <label
          htmlFor={`landing_components[${index}].config['associated_list']`}
          className="fs-6 mb-2"
        >
          Associated List
        </label>
        <input
          className="form-control"
          name={`landing_components[${index}].config['associated_list']`}
          placeholder={'Associated List'}
          onChange={handleChange}
          required={true}
          value={landing_cmp.config ? landing_cmp.config['associated_list'] : ''}
        />
      </div>
      <div className="form-group my-2">
        <label
          htmlFor={`landing_components[${index}].config['redirect_url']`}
          className="fs-6 mb-2"
        >
          Redirect URL
        </label>
        <input
          className="form-control"
          name={`landing_components[${index}].config['redirect_url']`}
          placeholder={'Redirect URL'}
          onChange={handleChange}
          required={true}
          value={landing_cmp.config ? landing_cmp.config['redirect_url'] : ''}
        />
      </div>
      <div className="form-group my-2">
        <label htmlFor={`landing_components[${index}].config['button_text']`} className="fs-6 mb-2">
          Button text
        </label>
        <input
          className="form-control"
          name={`landing_components[${index}].config['button_text']`}
          placeholder={'Button text'}
          onChange={handleChange}
          required={true}
          value={landing_cmp.config ? landing_cmp.config['button_text'] : ''}
        />
      </div>
    </>
  );
};

export default GenericFormForm;
